import React from 'react';
import { PrivacyPolicyContainer } from '../PrivacyPolicy/PrivacyStyles.styles';

const Services = () => {
  return (
    <PrivacyPolicyContainer>
      <h3>Services Provided</h3>
      <p>Yoda Safety Services provides access to the following services:</p>
      <ul>
        <li>
          <strong>Training Portal:</strong> Access to online training courses,
          quizzes, and other educational materials.
        </li>
        <li>
          <strong>Account Management:</strong> Tools for managing user and
          company accounts, including password resets and profile updates.
        </li>
        <li>
          <strong>Newsletters:</strong> Subscription-based newsletters and
          promotional content.
        </li>
        <li>
          <strong>Payment Processing:</strong> Secure payment processing for
          course purchases and other services through third-party providers like
          PayPal.
        </li>
      </ul>
      <h4>Modifications to Services</h4>
      <p>
        We reserve the right to modify, suspend, or discontinue any part of our
        platform or services at any time without prior notice. This includes
        changes to course content, pricing, or availability.
      </p>
      <h4>Service Availability</h4>
      <p>
        While we strive to provide uninterrupted access to our platform,
        services may be temporarily unavailable due to maintenance, technical
        issues, or other unforeseen circumstances.
      </p>
      <h4>User Responsibilities</h4>
      <p>
        Users are responsible for ensuring they have the necessary equipment,
        software, and internet connection to access our platform. We are not
        liable for any issues arising from user-side technical limitations.
      </p>
    </PrivacyPolicyContainer>
  );
};

export default Services;
